module.exports = __webpack_public_path__ + "media/images/icons/map-3977ddf5d168eaeb9631491bb8e0d075.svg";